export enum ProviderCapability {
  CHECKING_ACCOUNTS = 'CHECKING_ACCOUNTS',
  CREDIT_CARDS = 'CREDIT_CARDS',
  EINVOICES = 'EINVOICES',
  IDENTITY_DATA = 'IDENTITY_DATA',
  INVESTMENTS = 'INVESTMENTS',
  LIST_BENEFICIARIES = 'LIST_BENEFICIARIES',
  LOANS = 'LOANS',
  MORTGAGE_AGGREGATION = 'MORTGAGE_AGGREGATION',
  MORTGAGE_LOAN = 'MORTGAGE_LOAN',
  PAYMENTS = 'PAYMENTS',
  SAVINGS_ACCOUNTS = 'SAVINGS_ACCOUNTS',
  TRANSFERS = 'TRANSFERS',
  UNKNOWN = 'UNKNOWN',
}
